import { render, staticRenderFns } from "./UcrsTable.vue?vue&type=template&id=392cb21a"
import script from "./UcrsTable.vue?vue&type=script&lang=js"
export * from "./UcrsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports